import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import { Bar } from "../../icon/IconTheme";
const Header = () => {
	return (
		<header>
			<div className="container">
				<div className="header-wrapper">
					<Link to="/" className="logo me-auto">
						<img src={logo} alt="" />
					</Link>
					<Link to="#" className="cmn-btn">
						Connect Wallet
					</Link>
					<div className="bar">
						<Bar />
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
